import React, { useState, useEffect } from "react";
import { getExpiryNumber, getPlanProgress } from "../../../../Utils/utils";

export default function CircleProgress(props) {
  const { specificPlan } = props;

  const baseSingleSitePlan = Array.isArray(specificPlan)
    ? specificPlan.filter((plan) => plan.basePlan === true)
    : [];

  const featureDetails = baseSingleSitePlan[0]?.featureDetails;
  const numSites = featureDetails?.find(
    (feature) => feature.type === "NUM_SITES"
  );
  const storage = featureDetails?.find((feature) => feature.type === "STORAGE");
  const visits = featureDetails?.find((feature) => feature.type === "VISITS");

  const outerRadius = 90;
  const middleRadius = 80;
  const innerRadius = 50;
  const extraInnerRadius = 25;

  const outerStrokeWidth = 5;
  const middleStrokeWidth = 25;
  const innerStrokeWidth = 20;
  const extraInnerStrokeWidth = 15;

  const outerCircumference = 2 * Math.PI * (outerRadius - outerStrokeWidth / 2);

  const middleCircumference =
    2 * Math.PI * (middleRadius - middleStrokeWidth / 2);

  const innerCircumference = 2 * Math.PI * (innerRadius - innerStrokeWidth / 2);

  const extraInnerCircumference =
    2 * Math.PI * (extraInnerRadius - extraInnerStrokeWidth / 2);

  // Initial state for progress values
  const [planExpiry, setPlanExpiry] = useState(0);
  const [planVisits, sePlanVisits] = useState(0);
  const [planStorage, setPlanStorage] = useState(0);
  const [planSites, setPlanSites] = useState(0);

  const planProgress = getPlanProgress(
    baseSingleSitePlan[0]?.creationDate,
    baseSingleSitePlan[0]?.expirationDate,
  );

  useEffect(() => {
    setTimeout(() => {
      setPlanExpiry(planProgress.progress);
      sePlanVisits((parseInt(visits?.used) / visits?.limitOrAvailablity) * 100);
      setPlanStorage(
        (parseInt(storage?.used) / parseInt(storage?.limitOrAvailablity)) * 100
      );
      setPlanSites((numSites?.used / numSites?.limitOrAvailablity) * 100);
    }, 100);
  }, [planProgress.progress, storage, numSites]);

  const dashOffsetOuter =
    outerCircumference - (planExpiry / 100) * outerCircumference;

  const dashOffsetMiddle =
    middleCircumference - (planVisits / 100) * middleCircumference;

  const dashOffsetInner =
    innerCircumference - (planStorage / 100) * innerCircumference;

  const dashOffsetExtraInner =
    extraInnerCircumference - (planSites / 100) * extraInnerCircumference;

  const cx = outerRadius;
  const cy = outerRadius;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        width: outerRadius * 2,
        height: outerRadius * 2,
      }}
    >
      {/* Plan Expire Circle */}
      <svg
        width={outerRadius * 2}
        height={outerRadius * 2}
        style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}
      >
        <circle
          stroke="#f3f3f3"
          fill="none"
          cx={cx}
          cy={cy}
          r={outerRadius - outerStrokeWidth / 2}
          strokeWidth={outerStrokeWidth}
        />
        <circle
          stroke="#135fc2"
          fill="none"
          cx={cx}
          cy={cy}
          r={outerRadius - outerStrokeWidth / 2}
          strokeWidth={outerStrokeWidth}
          strokeDasharray={outerCircumference}
          strokeDashoffset={dashOffsetOuter}
          strokeLinecap="round"
          transform={`rotate(-90 ${cx} ${cy})`}
        />
      </svg>

      {/* Plan Visits Circle */}
      <svg
        width={outerRadius * 2}
        height={outerRadius * 2}
        style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}
      >
        <circle
          stroke="#f3f3f3"
          fill="none"
          cx={cx}
          cy={cy}
          r={middleRadius - middleStrokeWidth / 2}
          strokeWidth={middleStrokeWidth}
        />
        <circle
          stroke="#83aadb"
          fill="none"
          cx={cx}
          cy={cy}
          r={middleRadius - middleStrokeWidth / 2}
          strokeWidth={middleStrokeWidth}
          strokeDasharray={middleCircumference}
          strokeDashoffset={dashOffsetMiddle}
          strokeLinecap="round"
          transform={`rotate(-90 ${cx} ${cy})`}
        />
      </svg>

      {/* Plan Storage Circle */}
      <svg
        width={outerRadius * 2}
        height={outerRadius * 2}
        style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}
      >
        <circle
          stroke="#f3f3f3"
          fill="none"
          cx={cx}
          cy={cy}
          r={innerRadius - innerStrokeWidth / 2}
          strokeWidth={innerStrokeWidth}
        />
        <circle
          stroke="#cddaee"
          fill="none"
          cx={cx}
          cy={cy}
          r={innerRadius - innerStrokeWidth / 2}
          strokeWidth={innerStrokeWidth}
          strokeDasharray={innerCircumference}
          strokeDashoffset={dashOffsetInner}
          strokeLinecap="round"
          transform={`rotate(-90 ${cx} ${cy})`}
        />
      </svg>

      {/* Plan Sites Circle */}
      <svg
        width={outerRadius * 2}
        height={outerRadius * 2}
        style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}
      >
        <circle
          stroke="#fbf9f9"
          fill="none"
          cx={cx}
          cy={cy}
          r={extraInnerRadius - extraInnerStrokeWidth / 2}
          strokeWidth={extraInnerStrokeWidth}
        />
        <circle
          stroke="#e4eaf3"
          fill="none"
          cx={cx}
          cy={cy}
          r={extraInnerRadius - extraInnerStrokeWidth / 2}
          strokeWidth={extraInnerStrokeWidth}
          strokeDasharray={extraInnerCircumference}
          strokeDashoffset={dashOffsetExtraInner}
          strokeLinecap="round"
          transform={`rotate(-90 ${cx} ${cy})`}
        />
      </svg>
    </div>
  );
}
